import { render } from "./staffAttendance.vue?vue&type=template&id=0072c84c&scoped=true"
import script from "./staffAttendance.vue?vue&type=script&lang=js"
export * from "./staffAttendance.vue?vue&type=script&lang=js"

import "./staffAttendance.vue?vue&type=style&index=0&id=0072c84c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0072c84c"]])

export default __exports__